@use "Styles/mixins";
@use "Styles/includes/variables";

:host {
    display: block;
}

.vm-video-education-event-card {
    position: relative;
    display: flex;
    align-items: center;
    gap: 16px;
    padding: 16px 16px 16px 24px;
    border-radius: 8px;
    background: mixins.get-color(background, bg-gray-100);
    overflow: hidden;
    text-decoration: none;
    color: inherit;

    // Teal accent bar down the leading edge.
    &::before {
        content: "";
        position: absolute;
        inset: 0 auto 0 0;
        width: 4px;
        background: mixins.get-color(background, bg-brand-solid);
    }

    &__icon {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        width: 40px;
        height: 40px;
        border-radius: 50%;
        color: mixins.get-color(text, text-white);
        background: mixins.get-color(background, bg-brand-solid);
    }

    &__text {
        display: flex;
        flex-direction: column;
        gap: 4px;
        min-width: 0;
    }

    &__title {
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 4;
        line-clamp: 4;
        overflow: hidden;
        font-size: mixins.get-font-size(text-sm);
        line-height: mixins.get-line-height(text-sm);
        font-weight: 700;
        color: mixins.get-color(text, text-primary);
    }

    &__date {
        font-size: mixins.get-font-size(text-xs);
        line-height: mixins.get-line-height(text-xs);
        color: mixins.get-color(text, text-tertiary);
    }

    &__location {
        font-size: mixins.get-font-size(text-xs);
        line-height: mixins.get-line-height(text-xs);
        color: mixins.get-color(text, text-tertiary);
    }
}
